import { Box, Divider, styled, Tab, Tabs, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { apiGet, apiPost } from "../../utils/Api/ApiCalls";
import { API_ROUTES } from "../../utils/Api/ApiConfig";
import FeedsCart from "../../components/common/FeedsCart";
import CustomButton from "../../components/common/CustomButton";
import CreateFeed from "../../components/CreateFeedPopup";
import Loader from "../../components/common/Loader";
import NoFound from "../../components/NoFound";
import AlertBox from "../../components/AlertBox";

function Feeds() {
  const [feeds, setFeeds] = useState([]);
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedTabs, setSelectedTabs] = useState("feeds");
  const [editData, setEditData] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [render, setRender] = useState(false);

  useEffect(() => {
    getFetchFeed(selectedTabs);
  }, [render]);

  const getFetchFeed = async (collection) => {
    setLoader(true);
    try {
      const response = await apiGet(API_ROUTES.GET_FEED, {
        collection,
      });
      const value = response?.data?.posts;
      console.log(value);
      setFeeds(value);
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const feedsType = [
    { name: "Feeds", value: "feeds" },
    { name: "Banner (Home Page)", value: "banners" },
  ];

  const handleTabs = (_, value) => {
    setSelectedTabs(value);
    getFetchFeed(value);
  };

  const handleEditFeeds = (value) => {
    setEditData(value);
    setOpen(true);
  };
  const handleDeleteFeeds = (value) => {
    setSelectedId(value?._id);
  };

  const handleSubmit = async () => {
    const bodyData = {
      id: selectedId || null,
      action: selectedTabs || null,
      delete: true,
    };
    try {
      const response = await apiPost(API_ROUTES.POST_FEEDS, bodyData);
      if (response.status === 201) {
        setSelectedId(null);

        getFetchFeed(selectedTabs);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditData(null);
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <Container>
            <SubContainer>
              <HeadingContainer>
                <Typography>Feeds</Typography>
                <Tabs value={selectedTabs} onChange={handleTabs}>
                  {feedsType?.map((data, i) => (
                    <Tab label={data?.name} value={data?.value} key={i} />
                  ))}
                </Tabs>
                <CustomButton
                  title="Create"
                  handleClick={() => setOpen(true)}
                  sx={{
                    backgroundColor: "#E8503A",
                    color: "white",
                    padding: "0.3rem 2rem",
                    textTransform: "capitalize",
                  }}
                />
              </HeadingContainer>
              {feeds?.length ? (
                feeds?.map((data, i) => (
                  <Fragment key={i}>
                    <FeedsCart
                      data={data}
                      handleEdit={handleEditFeeds}
                      handleDelete={handleDeleteFeeds}
                    />
                    <Divider />
                  </Fragment>
                ))
              ) : (
                <NoFound
                  message="Could you kindly include a comprehensive FAQ section that addresses common questions and provides detailed answers to enhance user understanding and support?"
                  title="No feeds found"
                  btnText="Create Feed"
                  handleAction={() => setOpen(true)}
                />
              )}
            </SubContainer>
          </Container>
          <CreateFeed
            open={open}
            setOpen={handleClose}
            data={editData}
            feedsName={selectedTabs}
            setRender={setRender}
          />
          <AlertBox
            open={Boolean(selectedId)}
            handleClose={() => setSelectedId(null)}
            title="Delete Post"
            message="Are you sure you want to delete this post"
            handleSubmit={handleSubmit}
          />
        </>
      )}
    </>
  );
}

const Container = styled(Box)(({ theme }) => ({
  height: "100%",
  overflow: "auto",
}));
const HeadingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));
const SubContainer = styled(Box)(({ theme }) => ({
  width: "50%",
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
}));

export default Feeds;
